// src/components/TransactionCard.js - VERSIÓN CON MES
import React from 'react'
import { Trash2, Calendar, User } from 'lucide-react'

const TransactionCard = ({ transaction, onDelete, showUserInfo, showMonth = true }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount)
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    })
  }

  const formatMonth = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('es-ES', {
      month: 'long',
      year: 'numeric'
    })
  }

  const formatMonthShort = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('es-ES', {
      month: 'short',
      year: 'numeric'
    })
  }

  const getRelativeTime = (dateString) => {
    const date = new Date(dateString)
    const now = new Date()
    const diffTime = Math.abs(now - date)
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays === 0) return 'Hoy'
    if (diffDays === 1) return 'Ayer'
    if (diffDays < 7) return `Hace ${diffDays} días`
    if (diffDays < 30) return `Hace ${Math.floor(diffDays / 7)} semanas`
    if (diffDays < 365) return `Hace ${Math.floor(diffDays / 30)} meses`
    return `Hace ${Math.floor(diffDays / 365)} años`
  }

  const isIncome = transaction.type === 'income'
  const canDelete = onDelete && !showUserInfo

  return (
    <div className="px-6 py-4 hover:bg-gray-50 transition-colors">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {/* Icono de categoría */}
          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
            isIncome ? 'bg-green-100' : 'bg-red-100'
          }`}>
            <span className={`text-lg ${
              isIncome ? 'text-green-600' : 'text-red-600'
            }`}>
              {transaction.expense_categories?.icon || (isIncome ? '💰' : '💸')}
            </span>
          </div>

          {/* Detalles de la transacción */}
          <div className="flex-1">
            <div className="flex items-center space-x-2">
              <p className="text-sm font-medium text-gray-900">
                {transaction.concept}
              </p>
              {showUserInfo && (
                <div className="flex items-center space-x-1 text-xs text-gray-500">
                  <User className="h-3 w-3" />
                  <span>{transaction.profiles?.username}</span>
                </div>
              )}
            </div>
            
            <div className="flex items-center space-x-4 mt-1">
              {!isIncome && transaction.expense_categories && (
                <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                  {transaction.expense_categories.name}
                </span>
              )}
              
              <div className="flex items-center space-x-1 text-xs text-gray-500">
                <Calendar className="h-3 w-3" />
                <span>{formatDate(transaction.transaction_date)}</span>
              </div>

              {/* Mostrar mes si está habilitado */}
              {showMonth && (
                <div className="text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                  {formatMonthShort(transaction.transaction_date)}
                </div>
              )}

              {/* Tiempo relativo */}
              <div className="text-xs text-gray-400">
                {getRelativeTime(transaction.transaction_date)}
              </div>
            </div>
          </div>
        </div>

        {/* Cantidad y acciones */}
        <div className="flex items-center space-x-3">
          <div className="text-right">
            <p className={`text-lg font-semibold ${
              isIncome ? 'text-green-600' : 'text-red-600'
            }`}>
              {isIncome ? '+' : '-'}{formatCurrency(transaction.amount)}
            </p>
            
            {/* Mostrar mes grande en móvil */}
            <div className="block sm:hidden">
              <span className="text-xs text-gray-500">
                {formatMonth(transaction.transaction_date)}
              </span>
            </div>
          </div>

          {canDelete && (
            <button
              onClick={() => onDelete(transaction.id)}
              className="text-gray-400 hover:text-red-600 transition-colors p-1"
              title="Eliminar transacción"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default TransactionCard